<template>
    <div class="main-container">
        <div class="login-wrapper">
          <!-- Logo (above card) -->
          <img :src="logo" alt="Wingio Logo" class="mb-3" height="80">

          <!-- Card -->
          <div class="login-card text-center">
            <h6 class="mb-1 text-left pl-4 small"><b>Verify your email</b></h6>

            <div class="alert alert-info small text-left" role="alert">
              We've sent a verification code to <b>{{ email }}</b>. Please check your inbox (and spam folder) and enter the code below.
            </div>

            <form class="p-4 pt-2">
              <div class="form-group text-left mb-3">
                <label for="otp" class="form-label">Verification Code</label>
                <input
                  v-model="otp"
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  id="otp"
                  class="form-control"
                  placeholder="Enter code"
                  maxlength="6"
                  required
                >
              </div>

              <button type="submit" class="btn btn-primary w-100" :disabled="isDisabled" @click="verifyOtp()">
                Verify <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
              </button>

              <!--<div class="text-center pt-3">
                <a href="javascript:void(0)" @click="resendOtp()" class="small text-decoration-none" :class="{ 'disabled-link': resendDisabled }">
                  Didn't receive the code? <span v-if="!resendDisabled">Resend</span><span v-else>Resend in {{ resendCountdown }}s</span>
                </a>
              </div>-->

              <div class="text-center pt-2">
                <a href="javascript:void(0)" @click="$router.push('/login')" class="small text-decoration-none text-muted">
                  <i class="fa fa-arrow-left"></i> Back to login
                </a>
              </div>
            </form>
          </div>

          <p class="recaptcha-text">
            <a href="https://www.mywingio.com/privacy-policy">Privacy Policy</a> and
            <a href="https://www.mywingio.com/terms-of-service">Terms of Service</a> apply.
          </p>
        </div>
    </div>
</template>

<script>
import UserService from "../services/UserService";
export default {
  name: 'VerifyOtp',
  props: {
    logo: {
        type: String,
        default: "./images/lya-logo.png",
    },
  },
  data() {
    return {
      isDisabled: false,
      otp: null,
      email: this.$route.query.email,
      resendDisabled: false,
      resendCountdown: 30,
      resendTimer: null,
    };
  },
  methods: {
    verifyOtp() {
        if (!this.otp || this.otp.trim() === "") {
          this.$toast.error("Please enter the verification code");
          return;
        }

        this.isDisabled = true;
        var data = {
            otp: this.otp,
            email: this.email
        };
        UserService.verifyOtp(data)
            .then((response) => {
                this.isDisabled = false;
                this.$toast.success(response.data.respones_msg);
                document.location = "/kids-device";
            }).catch((e) => {
                this.isDisabled = false;
                this.$toast.error(e.response.data.respones_msg);
            });
    },
    resendOtp() {
      if (this.resendDisabled) return;

      UserService.resendOtp({ email: this.email })
        .then((response) => {
          this.$toast.success("A new code has been sent to your email");
          this.startResendCooldown();
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    startResendCooldown() {
      this.resendDisabled = true;
      this.resendCountdown = 30;
      this.resendTimer = setInterval(() => {
        this.resendCountdown--;
        if (this.resendCountdown <= 0) {
          clearInterval(this.resendTimer);
          this.resendDisabled = false;
        }
      }, 1000);
    },
  },
  beforeMount() {
  },
  beforeUnmount() {
    if (this.resendTimer) {
      clearInterval(this.resendTimer);
    }
  },
}
</script>

<style scoped>
.login-wrapper {
  max-width: 400px;
  text-align: center;
}
.login-card {
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  background: #fff;
}
.recaptcha-text {
  font-size: 11px;
  color: #6c757d;
  margin-top: 1rem;
}
.disabled-link {
  pointer-events: none;
  color: #6c757d;
}
</style>